module.exports = __webpack_public_path__ + "img/certification-demo2.da6d037a.png";